<template>
  <svg v-if="icon === 'check'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill="currentColor"
      d="m10.531 16.364 7.15-6.63-1.36-1.467-5.79 5.37-1.85-1.718-1.36 1.466 3.21 2.979Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM6.343 6.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 6.343 6.343Z"
      clip-rule="evenodd"
    />
  </svg>
  <SnowflakeIcon v-else-if="icon === 'snowflake'" />
  <CalendarIcon v-else-if="icon === 'calendar'" />
  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill="currentColor"
      d="M18.659 9.53c.392.115.708.415.85.796.148.394.085.855-.168 1.192a1.338 1.338 0 0 1-.82.516c.124.07.234.163.323.278a1.114 1.114 0 0 1-.189 1.553 1.11 1.11 0 0 1-.604.232c.11.067.209.155.29.258a1.117 1.117 0 0 1-.19 1.554c-.177.14-.383.215-.603.232.46.29.655.895.42 1.405-.188.413-.604.642-1.048.642H10.905c-.145 0-.29 0-.435-.01a2.762 2.762 0 0 1-.947-.23c-.108-.05-.214-.102-.322-.153l-.105-.051c-.027-.012-.043-.045-.043-.074v-.012a9.572 9.572 0 0 1-.002-.555l.002-.275v-5.991c0-.046.04-.086.086-.086h.076c.07.002.142.004.212-.005.245-.033.428-.193.534-.41l.09-.18.09-.182a442.374 442.374 0 0 1 1.06-2.138l.428-.863c.098-.196.14-.399.14-.615V4.84l-.001-.031c-.001-.03-.002-.06.004-.086.03-.122.134-.246.217-.333.2-.217.474-.343.765-.38.775-.1 1.377.517 1.621 1.195.246.675.15 1.396.058 2.094l-.017.122a67.429 67.429 0 0 1-.307 2.05c.05-.002.103 0 .154.003.038.002.075.004.11.004h3.799c.165 0 .326.005.486.051ZM8.125 10.627v.177h.002v7.105a.532.532 0 0 1-.485.537H7.64c-.012.003-.024.003-.036.003H5.501c-.03 0-.06 0-.091-.002a.53.53 0 0 1-.497-.497 2.947 2.947 0 0 1-.003-.256l.001-.113v-6.89c0-.062 0-.117.01-.179a.522.522 0 0 1 .487-.428c.025-.003.05-.002.074-.002H7.428c.09-.002.181-.004.269.01.261.042.426.28.428.535Z"
    />
  </svg>
</template>

<script setup lang="ts">
  interface Props {
    icon: string;
  }
  import { CalendarIcon } from '@heroicons/vue/outline';

  defineProps<Props>();
</script>
